import React, { useEffect, useState } from "react";
import HeaderTitle from "../HederTitle/HeaderTitle";
import { Link } from "react-router-dom";
import { currency } from "../../App";
import axios from "axios";
import { backend_url } from "../../App";

const RetroCollection = () => {
  const [bestSellers, setBestSellers] = useState([]);

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const response = await axios.get(`${backend_url}/api/topsellerretro`);
        const filteredSellers = response.data.filter(
          (item) => item.placeTo === "Retro Collections"
        );
        console.log(filteredSellers);
        setBestSellers(filteredSellers);
      } catch (error) {
        console.error("Error fetching Retro Collections:", error);
      }
    };

    fetchBestSellers();
  }, []);

  return (
    <div className="p-4">
      <HeaderTitle Header="Retro Collections" />
      <div className="p-4">
        {/* Horizontal scroll on mobile, grid on md+ screens */}
        {/* <div className="flex md:grid md:grid-cols-3 gap-6 overflow-x-auto scrollbar-hide"> */}
        <div className="flex flex-col md:grid md:grid-cols-4 gap-6 overflow-y-auto">
          {bestSellers.map((item) => (
            <div
              key={item._id}
              className="min-w-[80%] md:min-w-0 shadow-md rounded overflow-hidden transition-shadow duration-300 hover:shadow-lg flex-shrink-0"
            >
              <Link
                to={`/product/${item.productId?.id}/${item.productId?.name}`}
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="h-80 md:h-96 w-full flex items-center justify-center overflow-hidden">
                  <video
                    key={item.video}
                    src={`${item.video}`}
                    alt={item.productId?.name}
                    preload="auto"
                    loop
                    autoPlay
                    playsInline
                    muted
                    className="hover:scale-105 transition-transform duration-300 object-cover w-full h-full"
                  />
                </div>
              </Link>
              <div className="p-4">
                <p className="text-sm font-medium truncate">
                  {item.productId?.name}
                </p>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mt-2">
                  <div className="text-sm font-semibold text-purple-600">
                    {currency}
                    {item.productId?.old_price &&
                      Math.round(
                        (item.productId?.old_price *
                          (100 - item.productId?.new_price)) /
                          100
                      )}
                  </div>
                  <div className="text-xs text-gray-500">
                    {currency}
                    {item.productId?.old_price && (
                      <>
                        <span className="line-through">
                          ₹{item.productId?.old_price}
                        </span>
                        <span className="font-bold text-purple-600">
                          {` (${item.productId?.new_price}% OFF)`}
                        </span>
                        &nbsp;
                        <span>
                          {item.productId?.scale === "Meters"
                            ? "/meter"
                            : "/piece"}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
          {bestSellers.length === 0 && (
            <p className="text-center col-span-3">
              No retro collections found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RetroCollection;
